var ApiError = require('../models/errors/midas/apiError'),
  base64Url = require('sixtyfour'),
  cache = require('../models/cache'),
  configManager = require('../config/configManager'),
  CONST_MESSAGES = require('../constants/messages'),
  jwtLib = require('jsrsasign').jws,
  log = require('../libraries/logger').getLoggerInstance('Base.JWTUtility'),
  ServiceError = require('../models/errors/midas/serviceError'),
  uuid = require('uuid');

var publicMethods = {
  /**
   * Manually parse a JWS
   * @param {string} jwt The jwt to parse and decode
   * @returns {string} the JWT payload parsed as a string of JSON. Undefined if the payload was unable to be decoded.
   */
  parse: function (jwt) {
    var jwtParts = (jwt ? jwt.split('.') : []),
      encPayload = (jwtParts.length > 1 ? jwtParts[1] : false);

    if (encPayload) {
      var parsedJSON = base64Url.decodeJson(encPayload);
      if (parsedJSON) {
        log.debug('JWT decoded successfully');
        return parsedJSON;
      }
    }

    return undefined;
  },
  /**
   * Parses a string jwt into a JSON payload object. No additional processing is completed beyond conversion.
   * @param {string} rawJwt raw jwt response string from Centinel API
   * @returns {Object} JSON object of response payload
   */
  parseResponse: function (rawJwt) {
    var decodedJwt, decodedMessage;

    if (!rawJwt) {
      throw new Error('Invalid response JWT');
    }

    decodedJwt = publicMethods.parse(rawJwt);
    decodedMessage = decodedJwt.Payload;

    if (typeof decodedMessage === 'string') {
      decodedMessage = JSON.parse(decodedMessage);
      decodedJwt.Payload = decodedMessage;
    }

    if (decodedMessage !== undefined && (decodedMessage.ErrorNumber !== undefined)) {
      if (decodedMessage.ErrorNumber !== CONST_MESSAGES.RESPONSES.NOERROR) {
        log.warn('API error [' + decodedMessage.ErrorNumber + '] desc [' + decodedMessage.ErrorDescription + ']');
      }

      return decodedJwt;
    }
  },
  /**
   * Process a string response from Centinel API and throw exceptions based of the response for Service or API level errors. Ideal for using directly after a Centinel API request to handle common failure cases.
   * @param {string} responseJwt raw string response jwt from Centinel API
   * @returns {{decodedObject: Object, rawJwt: string}} responseObject an object containing the decoded jwt payload as a JSON object and the original response jwt string.
   * @throws {ApiError | ServiceError | Error}
   */
  unpackResponseJwt: function (responseJwt) {
    var decodedResponse;
    if (responseJwt) {
      if (responseJwt.CardinalJWT) {
        decodedResponse = publicMethods.parseResponse(responseJwt.CardinalJWT);

        if (decodedResponse && decodedResponse.Payload && decodedResponse.Payload.ErrorNumber === CONST_MESSAGES.RESPONSES.NOERROR) {
          log.debug('Cardinal response returned as successful');

          return {
            decodedObject: decodedResponse,
            rawJwt: responseJwt.CardinalJWT
          };
        } else {
          log.debug('Cardinal response returned a failure with an API level Error');
          throw new ApiError(decodedResponse, responseJwt.CardinalJWT);

        }
      } else {
        log.debug('Cardinal response returned a failure with a Service level Error');
        throw new ServiceError(responseJwt, responseJwt.CardinalJWT);
      }
    } else {
      log.info('Cardinal failed to return a response');
      throw new Error('No response to unpack');
    }
  },
  /**
   * Generates a client side JWT. This should never be used for anything other than simple CCA integrations that require client side JWT's.
   * @param {string} apiIdentifier Merchant Identifier
   * @param {string} apiKey Merchant Api Key
   * @param {string} orgUnitId Merchant OrgUnitId
   * @param {Object} orderPayload Order object to send to Centinel API
   */
  generateJwt: function (apiIdentifier, apiKey, orgUnitId, orderPayload) {
    return jwtLib.JWS.sign(configManager.getSystemConfig().defaultJWTAlgorithm, privateMethods.generateHeader(), privateMethods.assignClaims(apiIdentifier, orgUnitId, orderPayload), apiKey);
  },
  /**
   * Parses a JWT and pulls out Identifiers used in remote logging
   * @param {string} rawJwt - A string JWT should be used to pull information from
   */
  parseJwtForLogs: function (rawJwt) {
    var jwtClaims;

    if (rawJwt !== undefined) {

      jwtClaims = publicMethods.parse(rawJwt);

      if (jwtClaims instanceof String) {
        jwtClaims = JSON.parse(jwtClaims);
      }

      cache.apiId = jwtClaims.iss;
      cache.jti = jwtClaims.jti;
      cache.orgUnitId = jwtClaims.OrgUnitId;

      if (jwtClaims.Payload !== undefined) {
        if (typeof jwtClaims.Payload === 'string') {
          try {
            cache.jwtOrderObject = JSON.parse(jwtClaims.Payload);
          } catch (error) {
            log.error('Failed to parse stringified JWT Payload', error);
          }
        } else {
          cache.jwtOrderObject = jwtClaims.Payload;
        }
      }
    }

  }
},
  privateMethods = {
    generateHeader: function () {
      return JSON.stringify({ alg: configManager.getSystemConfig().defaultJWTAlgorithm, typ: 'JWT' });
    },
    assignClaims: function (apiIdentifier, orgUnitId, orderPayload) {
      var jwtPayload = {};

      jwtPayload.iat = jwtLib.IntDate.get('now');
      // NEXTREV: set default timeout in config and make configurable
      jwtPayload.exp = jwtLib.IntDate.get('now + 1hour');
      jwtPayload.jti = uuid.v4();
      jwtPayload.iss = apiIdentifier;
      jwtPayload.OrgUnitId = orgUnitId;

      if (orderPayload) {
        jwtPayload.ObjectifyPayload = true;
        jwtPayload.Payload = orderPayload;
      }

      return jwtPayload;
    }
  };

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./utilities/jwtUtility.js
// module id = 71
// module chunks = 5